
export default {
  layout: 'm_index'
}
